import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Select, Spin, Typography } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import {
  ADD_BTN,
  CHECKLISTS_REQUIRED,
  GUTTER,
  PLACEHOLDER,
} from '@moxie/constants';
import { CloseOutlined } from '@ant-design/icons';
import { Button, SearchableSelect } from '@shared-components/elements';
import { useAppSelector, workflowActions } from '@crm/core';
import { IChecklistData, IStageChecklist } from '@shared-components/models';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { RootState } from 'apps/crm/src/core/store';
import { addWfStageChecklist } from 'apps/crm/src/libs/services.api/lib/workflow.api';
import { Key } from 'rc-select/lib/interface/generator';

const WorkflowStageChecklists = ({ stageId }: { stageId: string }) => {
  const [form] = useForm();
  const { Option, OptGroup } = Select;
  const dispatch = useDispatch();
  const groupedData: any = [];
  const allChecklists = useAppSelector(
    (state) => state.workflows.allChecklists
  );

  const { checklists, loading } = useAppSelector((state: RootState) => ({
    checklists: state.workflows.checklists,
    loading: state.workflows.checklists_loading,
  }));

  const [allChecklistArray, setAllChecklistArray] = useState<IChecklistData[]>(
    []
  );
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    form.resetFields();
  }, [stageId]);

  useEffect(() => {
    const formatData = allChecklists.filter((item: IChecklistData) => {
      return !checklists.find((obj: IStageChecklist) => {
        return item.id === obj.checklist.id;
      });
    });
    const groupData = _.groupBy(formatData, 'type');
    groupedData.push(groupData);
    setAllChecklistArray(groupedData[0]);

    return () => {
      form.resetFields();
    };
  }, [checklists, dispatch]);

  const handlePostChecklist = async (data: Array<number>) => {
    setSubmitted(true);
    await addWfStageChecklist({ stageId, data });
    dispatch(workflowActions.getWfStageChecklists(stageId));
    form.resetFields();
    setSubmitted(false);
  };

  const handleDeleteChecklist = (id: string) => {
    dispatch(workflowActions.deleteStageChecklistRequest(id));
  };

  return (
    <div className="margin-top-2">
      <Spin spinning={loading || submitted}>
        <Form form={form} layout="vertical" onFinish={handlePostChecklist}>
          <Row gutter={GUTTER}>
            <Col span={21}>
              <Form.Item
                name="checklists"
                rules={[{ required: true, message: CHECKLISTS_REQUIRED }]}
              >
                <SearchableSelect
                  placeholder={PLACEHOLDER.MULTIPLE_CHECKLISTS}
                  mode="multiple"
                >
                  {Object.entries(allChecklistArray).map(
                    (item: any, index: number) => (
                      <OptGroup label={item[0]} key={index}>
                        {item[1]?.map((pos: { id: Key; name: string }) => {
                          return (
                            <Option
                              value={pos?.id}
                              key={pos?.name}
                              className="document-option-type"
                            >
                              {pos.name}
                            </Option>
                          );
                        })}
                      </OptGroup>
                    )
                  )}
                </SearchableSelect>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button htmlType="submit" type="primary">
                {ADD_BTN}
              </Button>
            </Col>
          </Row>
        </Form>
        <Row gutter={[16, 16]} className="padding-x1 margin-top-2">
          {checklists &&
            checklists.map((stageChecklist: IStageChecklist) => {
              return (
                <Col
                  key={stageChecklist.id}
                  span={7}
                  className="checklist-items"
                >
                  <>
                    <Col>
                      <Typography.Text strong>
                        {stageChecklist.checklist.name}
                      </Typography.Text>
                    </Col>
                    <Col
                      onClick={() => handleDeleteChecklist(stageChecklist.id)}
                    >
                      <CloseOutlined />
                    </Col>
                  </>
                </Col>
              );
            })}
        </Row>
      </Spin>
    </div>
  );
};
export { WorkflowStageChecklists };
